<template>
  <MRow :gutter="0" class="mt-4">
    <MCol :size="3">
      <FlotoStatusPicker
        disabled
        :value="value.statusId"
        :placeholder="disabled ? '---' : undefined"
        :module-name="moduleName"
        @change="handleChange({ statusId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="`${$tc('status')}`"
            icon-name="status"
            disabled
          />
        </template>
      </FlotoStatusPicker>
    </MCol>
    <MCol :size="3">
      <div>
        <FlotoTechnicianPicker
          size="default"
          :value="value.technicianId"
          :disabled="disabled"
          @change="handleChange({ technicianId: $event })"
        >
          <template v-slot:trigger="slotData">
            <FlotoDropdownTrigger
              v-bind="slotData"
              :lable="`${$tc('owner')}`"
              icon-name="question"
              :disabled="disabled"
            >
              <template v-slot:icon>
                <FlotoUserAvatar
                  :size="34"
                  :avatar="(slotData.currentItem || {}).avatar"
                  :style="{
                    minWidth: `${24}px`,
                  }"
                />
              </template>
            </FlotoDropdownTrigger>
          </template>
        </FlotoTechnicianPicker>
      </div>
    </MCol>
    <MCol :size="3">
      <CostCenterPicker
        :as-input="false"
        :allow-clear="false"
        :value="value.costCenter"
        :disabled="disabled"
        :placeholder="disabled ? '---' : undefined"
        @change="handleChange({ costCenter: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="`${$tc('cost_center')}`"
            icon-name="dollar-sign"
            :disabled="disabled"
          />
        </template>
      </CostCenterPicker>
    </MCol>
    <MCol :size="3">
      <!-- <MTooltip class="inline-flex items-center" placement="topLeft">
        <template v-slot:trigger>
          <MIcon name="user" size="2x" class="mr-4 text-neutral-light" /> -->
      <VendorPicker
        :as-input="false"
        :allow-clear="false"
        :value="value.vendorId"
        disabled
        :placeholder="disabled ? '---' : undefined"
        @change="handleChange({ vendorId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="{
              ...slotData,
              ...(Object.keys(slotData.currentItem || {}).length
                ? {
                    currentItem: {
                      ...slotData.currentItem,
                      lable: `${(slotData.currentItem || {}).name}: ${
                        (slotData.currentItem || {}).text
                      }`,
                    },
                  }
                : {}),
            }"
            :lable="`${$tc('vendor')}`"
            icon-name="user"
            disabled
          />
        </template>
      </VendorPicker>
      <!-- </template>
        {{ $tc('vendor') }}
      </MTooltip> -->
    </MCol>
  </MRow>
</template>

<script>
import VendorPicker from '@components/data-picker/vendor-picker'
import CostCenterPicker from '@components/data-picker/cost-center-picker'
export default {
  name: 'PrimaryRow',
  components: { VendorPicker, CostCenterPicker },
  model: {
    event: 'change',
  },
  props: {
    disabled: { type: Boolean, default: false },
    value: { type: Object, required: true },
    moduleName: { type: String, required: true },
  },
  methods: {
    handleChange(change) {
      this.$emit('change', change)
    },
  },
}
</script>
